import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import Modal from '@mui/material/Modal';
import { LoaderContainer } from './styles';

function Loader({ open = false }) {
  const disableAutoFocus = true;

  return (
    <Modal open={open} disableAutoFocus={disableAutoFocus}>
      <LoaderContainer data-testid="container-modalProgress">
        <CircularProgress />
      </LoaderContainer>
    </Modal>
  );
}

Loader.propTypes = {
  open: PropTypes.bool,
};

export default Loader;
